import React from "react";
import ToolTip from "shared/components/tooltip";
import Size from "shared/enums/Size";
import { TooltipSize } from "../tooltip/tooltip.type";

function LabelWithTooltip({
  size = Size.SMALL,
  ...props
}: {
  size?: TooltipSize;
  label: string;
  tooltipContent?: string;
}) {
  return (
    <React.Fragment>
      {props.label}
      {props.tooltipContent && <ToolTip content={props.tooltipContent} size={size} />}
    </React.Fragment>
  );
}

export default LabelWithTooltip;
